<script setup lang="ts">
import { computed, ref } from 'vue';
import Field from './Field.vue';
import { minValue, maxValue } from '@/models/OcularAxis'

const props = defineProps({
    modelValue: {
        type: Number,
        required: false,
    }
})
const emit = defineEmits(['update:modelValue'])
const valueFromInput = ref('')

const valueToInput = computed({
    get(): string {
        return errorMessage.value 
            ? valueFromInput.value
            : !Number.isNaN(props.modelValue) ? (props.modelValue?.toString() || '0') : ''
    },
    set(newValue: string){
        valueFromInput.value = newValue
    }
})
const errorMessage = ref<string|undefined>()

function emitValue(newValue: string)
{
    const value = parseFloat(newValue.replace(',', '.'))

    if(
        Number.isNaN(value)
        || (value < minValue || value > maxValue)
    ) {
        errorMessage.value = 'Value invalid'
        valueFromInput.value = newValue
        emit('update:modelValue', 0)
        return
    }

    errorMessage.value = undefined
    emit('update:modelValue', value)
}
</script>

<template>
    <Field 
        alignText="right" 
        info="(0-180)"
        :error="errorMessage"
        :modelValue="valueToInput"
        @update:modelValue="emitValue"
    />
</template>